/** @format */

import { END_POINT } from "utils";
import { deleteRequest, getRequest, patchRequest, postRequest } from "./axios";
import type { WmsItem } from "types";

let cachedWmsItems: WmsItem[] | null = null;
let inflight: Promise<WmsItem[]> | null = null;

export const wmsItemService = {
  show: async (id: number | string) => {
    const rs = await getRequest(`${END_POINT.WMS_ITEMS.LIST}/${id}`);
    return rs.data;
  },
  list: async (): Promise<WmsItem[]> => {
    if (cachedWmsItems) return cachedWmsItems;
    if (inflight) return inflight;

    inflight = getRequest(END_POINT.WMS_ITEMS.LIST)
      .then((rs) => rs.data?.data ?? rs.data ?? [])
      .catch(() => [])
      .finally(() => {
        inflight = null;
      });

    cachedWmsItems = await inflight;
    return cachedWmsItems;
  },
  create: async (payload: WmsItem) => {
    const rs = await postRequest(END_POINT.WMS_ITEMS.LIST, payload);
    cachedWmsItems = null;
    return rs.data;
  },
  update: async (id: number | string, payload: WmsItem) => {
    const rs = await patchRequest(`${END_POINT.WMS_ITEMS.LIST}/${id}`, payload);
    cachedWmsItems = null;
    return rs.data;
  },
  destroy: async (id: number | string) => {
    const rs = await deleteRequest(`${END_POINT.WMS_ITEMS.LIST}/${id}`);
    cachedWmsItems = null;
    return rs.data;
  },
};
